import { ROLE_PLAY_TYPE_RESULT_RELATIONS } from "@/lib/role-plays/scenario-types";

// What an assignment list reads of its linked result, on every type's
// relation: the score, and the feedback items that carry the must-pass
// verdict (lib/feedback/structuredFeedbackShape.js `hasMissedMustPass`).
const ASSIGNMENT_RESULT_SELECT = { id: true, totalScore: true, feedbackStructured: true };
export const ASSIGNMENT_RESULT_INCLUDE = Object.fromEntries(
  Object.values(ROLE_PLAY_TYPE_RESULT_RELATIONS).map((relation) => [
    relation,
    { select: ASSIGNMENT_RESULT_SELECT },
  ]),
);

/**
 * The result linked to an assignment, whichever type's relation holds it. An
 * assignment links at most one, so the first loaded relation is the answer.
 */
export function getRolePlayAssignmentResult(assignment) {
  for (const relation of Object.values(ROLE_PLAY_TYPE_RESULT_RELATIONS)) {
    if (assignment?.[relation]) return assignment[relation];
  }
  return null;
}

export function isRolePlayAssignmentPending(assignment) {
  if (!assignment || assignment.completedAt) return false;

  const passingScore = assignment.rolePlay?.passingScore;
  if (passingScore === null || passingScore === undefined) return true;

  const result = getRolePlayAssignmentResult(assignment);
  if (
    !result ||
    typeof result.totalScore !== "number" ||
    !Number.isFinite(result.totalScore)
  ) {
    return true;
  }

  return result.totalScore < passingScore;
}

/**
 * How many practice simulations a practice-mode (unscored) roleplay asks for.
 * A scenario saved before the field existed carries null, which has always
 * meant three. Every reader of the requirement goes through this so the
 * default lives in one place.
 */
export const DEFAULT_MIN_PRACTICE_SIMULATIONS = 3;

export function getMinPracticeSimulations(rolePlay) {
  return rolePlay?.minPracticeSimulations || DEFAULT_MIN_PRACTICE_SIMULATIONS;
}
